import { render, staticRenderFns } from "./TheUserNew.vue?vue&type=template&id=535236fa"
import script from "./TheUserNew.vue?vue&type=script&lang=js"
export * from "./TheUserNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports